module.exports = __webpack_public_path__ + "static/img/big.15cf3f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/big.png
// module id = 0LXY
// module chunks = 1